































import { Vue, Component, Prop } from "vue-property-decorator";
import ErrorField from "../../components/inputs/ErrorField.vue";
import { TeacherFileDTO } from "../../../src_server/entity/dto/TeacherFileDTO";
import { InputPages } from "../../components/organisms/InputPages";

@Component({ components: { ErrorField } })
export default class FileInput extends InputPages {
  @Prop({ default: new TeacherFileDTO() })
  private file!: TeacherFileDTO;

  @Prop({ default: "" })
  path!: string;

  private file_error = "";

  get fileModel() {
    return this.file;
  }

  set fileModel(value) {
    console.log("fileModel");
    // this.file = value;
    this.file_error = "";
    this.$emit("file-upload", value);
  }

  get showOldImage() {
    return !this.hasNewInput && this.path;
  }

  get hasNewInput() {
    return this.fileModel && this.fileModel.icon_image_client_url;
  }

  validate() {
    // パスが入っているパターンは、プロフィール再編集、その場合は新規で入力しなくてもいい
    if (this.path) {
      this.file_error = "";
      return true;
    }
    const isValid = !!this.fileModel.icon_image_client_url;

    console.log("isValid", isValid, this.fileModel.icon_image_client_url);
    if (!isValid) this.file_error = "アイコン写真は必ず入力してください";

    return isValid;
  }

  async fileInput(event: Event) {
    console.log(event);
    const files = (event.target as HTMLInputElement)?.files;
    if (!files) return;
    const file = files[0];
    const modelFile = new TeacherFileDTO();
    modelFile.icon_image_client_url = URL.createObjectURL(file);
    modelFile.icon_image_file = file;
    this.fileModel = modelFile;
    // this.fileModel.icon_image_client_url = URL.createObjectURL(file);
    // this.fileModel.icon_image_file = file;

    console.log(files);
  }
}
